import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=3aa3aadd&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"
import style0 from "./LandingPageView.vue?vue&type=style&index=0&id=3aa3aadd&prod&scoped=true&lang=scss"
import style1 from "./LandingPageView.vue?vue&type=style&index=1&id=3aa3aadd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3aadd",
  null
  
)

export default component.exports